export const ESCOLA_EDIT_FILTER_MUNICIPAL = 0;
export const ESCOLA_EDIT_FILTER_ESTADUAL = 1;
export const ESCOLA_EDIT_FILTER_PRIVADA = 2;

const allTipoDeInstuicao = [];
allTipoDeInstuicao[ESCOLA_EDIT_FILTER_MUNICIPAL] = {
  name: 'Municipal',
};
allTipoDeInstuicao[ESCOLA_EDIT_FILTER_ESTADUAL] = {
  name: 'Estadual',
};
allTipoDeInstuicao[ESCOLA_EDIT_FILTER_PRIVADA] = {
  name: 'Privada',
};

function getName(index) {
  if (index < allTipoDeInstuicao.length) {
    return allTipoDeInstuicao[index].name;
  }
  return null;
}

export { allTipoDeInstuicao, getName };
